module.exports = __webpack_public_path__ + "static/img/11.13388a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/zh/11.png
// module id = CYiF
// module chunks = 0